import { themeQuartz, iconSetMaterial } from 'ag-grid-community';

// to use assortmentStripedGridTheme in an application, pass it to the theme grid option
const assortmentStripedGridTheme = themeQuartz.withPart(iconSetMaterial).withParams({
  accentColor: '#03549C', // $rtls-aqua-70
  backgroundColor: '#ffffff',
  borderRadius: 2,
  browserColorScheme: 'light',
  cellHorizontalPaddingScale: 0.7,
  cellFontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  columnBorder: false,
  fontSize: 12,
  fontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  foregroundColor: '#2E3742',
  headerBackgroundColor: '#FFFFFF',
  headerFontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
  headerHeight: 30,
  headerFontSize: 13,
  headerFontWeight: 600,
  headerTextColor: '#37424a',
  iconSize: 14,
  oddRowBackgroundColor: '#F9FAFB',
  pinnedColumnBorder: true,
  rowBorder: false,
  rowVerticalPaddingScale: 0.8,
  sidePanelBorder: true,
  spacing: 8,
  wrapperBorder: false,
  wrapperBorderRadius: 2,
});

export default assortmentStripedGridTheme;
